import clsx from 'clsx'
import { useState } from 'react'
import { CaretRight } from 'phosphor-react'

import { type TaskDomain } from '../../../../types/domain/task-domain'
import { DialogModal } from '../../../../components/DialogModal'
import { TaskForm } from '../../Projects/components/TaskForm/TaskForm'
import { truncateWithEllipsis } from '../../../../utils/truncateWithEllipsis'

type TaskProps = {
  task: TaskDomain
}

export const Task = ({ task }: TaskProps) => {
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false)

  return (
    <>
      <div
        className={clsx(
          'flex items-center justify-between w-full px-5 py-4 rounded-xl bg-grey-100',
          {
            'opacity-50': task.done,
          }
        )}
      >
        <div className="flex flex-col gap-4 w-[calc(100%_-_24px)]">
          <p>{task.name}</p>

          {task.status === 'start' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#E7E7E7] text-[#5E5E61]">
              Início
            </div>
          )}

          {task.status === 'profile' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#ECDEFF] text-[#8628FF]">
              Perfil
            </div>
          )}

          {task.status === 'availability' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#E0FFFF] text-[#2E9A9A]">
              Disponibilidade
            </div>
          )}

          {task.status === 'scheduled' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#DBF6FF] text-[#4A7D9A]">
              Agendado
            </div>
          )}

          {task.status === 'accomplished' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#EEFFD8] text-[#49851F]">
              Realizado
            </div>
          )}

          {task.status === 'canceled' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#FFE7E7] text-[#FF4949]">
              Cancelado
            </div>
          )}

          {task.status === 'refused' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#FFEDD4] text-[#F05803]">
              Recusado
            </div>
          )}

          {task.status === 'onhold' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#FFFBD8] text-[#CEA100]">
              On hold
            </div>
          )}

          {task.status === 'finished' && (
            <div className="w-fit rounded-lg py-2 px-4 bg-[#E0FAE2] text-[#08B919]">
              Finalizado
            </div>
          )}
        </div>

        <button type="button" onClick={() => setIsTaskModalOpen(true)}>
          <CaretRight size={24} className="text-grey-700" />
        </button>
      </div>

      <DialogModal
        isOpen={isTaskModalOpen}
        title={truncateWithEllipsis(task.name, 100)}
        onClose={() => setIsTaskModalOpen(false)}
        styleBox={{ maxWidth: '1300px' }}
      >
        <TaskForm
          selectedTask={task}
          project={task.project}
          onClose={() => setIsTaskModalOpen(false)}
        />
      </DialogModal>
    </>
  )
}
